function initSizeGuides(root) {
  root.querySelectorAll('.size-guide__content:not([data-size-guide-initialized])').forEach((content) => {
    content.dataset.sizeGuideInitialized = 'true';

    const buttons = content.querySelectorAll('.size-guide__unit-btn');
    const tables = content.querySelectorAll('[data-unit-table]');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const unit = button.dataset.unit;

        buttons.forEach((btn) => {
          const isActive = btn === button;
          btn.classList.toggle('is-active', isActive);
          btn.setAttribute('aria-pressed', String(isActive));
        });

        tables.forEach((table) => {
          table.hidden = table.dataset.unitTable !== unit;
        });
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initSizeGuides(document));
document.addEventListener('shopify:section:load', (event) => initSizeGuides(event.target));
initSizeGuides(document);
